// Presentation only: preserve merchant text, links and numbering.
function tidyInformationPages() {
  document.querySelectorAll('.og-information-page .page-content p, .og-information-page .page-content div').forEach((element) => {
    if (!element.textContent.trim() && !element.querySelector('img, svg, iframe, input, button, video, table')) {
      element.hidden = true;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tidyInformationPages, { once: true });
} else {
  tidyInformationPages();
}
document.addEventListener('shopify:section:load', tidyInformationPages);
